// Auto-generated from .env
export const environment = {
  production: false,
  lsKey: 'tZJaq7zy3buBxQAPTPv4',
  serverBasePath: 'https://dental-360-int-dev.hasura.app',
  serverPath: 'https://qa-api.dentalinterface360.com',
  x_hasura_admin_secret: 'ZfEloN3LsZMG8ooRJCdToQQhMhALea6s0i2VwzhvV76XuDxuwGc9A25kRLDghYwO',
  hasuraInternalUrl: 'https://dental-interface-dev.hasura.app/v1/graphql',
  hasuraExternalHttpUrl: 'https://dental-interface-dev.hasura.app/v1/graphql',
  hasuraExternalWssUrl: 'wss://dental-interface-dev.hasura.app/v1/graphql',
  siteUrl: 'https://localhost:4200',
  otherId: '666d85af-62a7-4c5d-9dba-c30f7c589b4d',
  frontendPath: 'https://qa.dentalinterface360.com'
};
